module.exports = __webpack_public_path__ + "716a057a9e1a18cef2a2494ed3144612.svg";